var map = {
	"./1.png": 3930,
	"./2.png": 6137,
	"./3.png": 2395,
	"./4.png": 8279,
	"./5.png": 2581,
	"./6.png": 3341,
	"./Avast.png": 1876,
	"./Logo_lana/Logo_Lana.svg": 3649,
	"./Logo_lana/Logo_lana.png": 7858,
	"./Logo_lana/Logo_lana_modifie.jpg": 9332,
	"./Sail-Away-100x50.jpg": 3088,
	"./Sail-Away.jpg": 4830,
	"./agency-skill.jpg": 684,
	"./apporoach_man_img.png": 7261,
	"./apporoach_man_img_old.png": 1739,
	"./arrow.png": 9489,
	"./asan.png": 7854,
	"./banner_img.svg": 4521,
	"./blog-1.jpg": 2166,
	"./blog-2.jpg": 7170,
	"./brakets.png": 4371,
	"./bulb.png": 1452,
	"./c++.png": 8943,
	"./circle-2.png": 8907,
	"./contact.svg": 1049,
	"./cool.png": 5126,
	"./creative_bg1-100x50.jpg": 4386,
	"./creative_bg1.jpg": 5389,
	"./css_1.png": 6406,
	"./css_2.png": 530,
	"./cup.png": 7917,
	"./design.png": 7613,
	"./developer-img/10.png": 1091,
	"./developer-img/1009269.jpg": 5963,
	"./developer-img/1302261.jpg": 526,
	"./developer-img/1323866.jpg": 764,
	"./developer-img/angular.png": 3392,
	"./developer-img/code.png": 3414,
	"./developer-img/design-logo1.png": 1212,
	"./developer-img/design-logo2.png": 4286,
	"./developer-img/design-logo3.png": 3885,
	"./developer-img/design-logo4.png": 5901,
	"./developer-img/design-logo5.png": 6883,
	"./developer-img/dot.png": 1692,
	"./developer-img/dot_big.png": 6001,
	"./developer-img/html.png": 2447,
	"./developer-img/logo1.png": 6379,
	"./developer-img/logo2.png": 1011,
	"./developer-img/man.png": 8988,
	"./developer-img/mern.png": 6657,
	"./developer-img/polygon.png": 5727,
	"./developer-img/pr1.jpg": 4767,
	"./developer-img/pr2.jpg": 348,
	"./developer-img/pr3.jpg": 7249,
	"./developer-img/react.png": 4092,
	"./developer-img/shap.png": 92,
	"./developer-img/testimonial_bg_circle.png": 4831,
	"./developer-img/video_shap.png": 2805,
	"./dot.png": 8442,
	"./f_man.png": 5472,
	"./grid-70.png": 4485,
	"./h_pijom1.png": 175,
	"./icebg-100x50.jpg": 6550,
	"./icebg.jpg": 1811,
	"./img-1.png": 9822,
	"./img-3.png": 6996,
	"./img-4.png": 5813,
	"./img-5.png": 8206,
	"./img-6.png": 1408,
	"./img-8.png": 9874,
	"./img.svg": 5599,
	"./intro-bg.jpg": 6328,
	"./logo-blue.png": 7822,
	"./logo.png": 6105,
	"./logo2.png": 7997,
	"./man.jpg": 2643,
	"./man_old.jpg": 9539,
	"./mobile.svg": 756,
	"./new-page/arrow.png": 3927,
	"./new-page/bottomshape.png": 583,
	"./new-page/dot.png": 8498,
	"./new-page/line1.png": 5263,
	"./new-page/line2.png": 9217,
	"./new-page/line3.png": 8537,
	"./new-page/line4.png": 224,
	"./new-page/shape1.png": 3652,
	"./new-page/shape2.png": 3,
	"./new-page/shape3.png": 7444,
	"./new-page/slider_img1.jpg": 3949,
	"./new-page/slider_img2.jpg": 754,
	"./new-page/slider_img3.jpg": 5658,
	"./new-page/slider_img4.jpg": 2847,
	"./new-page/topshape.png": 8471,
	"./new-page/topshape2.png": 1930,
	"./new1.jpg": 1247,
	"./our-coaches-2.jpg": 889,
	"./our-coaches-7.jpg": 2087,
	"./php.png": 3305,
	"./pijom_2.png": 4924,
	"./play1.png": 3768,
	"./play2.png": 5585,
	"./portfolio/1.jpg": 1086,
	"./portfolio/10.jpg": 4512,
	"./portfolio/2.jpg": 7097,
	"./portfolio/3.jpg": 112,
	"./portfolio/4.jpg": 5564,
	"./portfolio/4_bis.jpg": 6236,
	"./portfolio/9.jpg": 3912,
	"./portfolio/img-3.jpg": 7713,
	"./portfolio1.jpg": 2074,
	"./portfolio2.jpg": 3725,
	"./post-img1.jpg": 9997,
	"./post-img2.jpg": 5437,
	"./post-img3.jpg": 6515,
	"./profile.jpg": 3560,
	"./search.png": 2985,
	"./service.svg": 6273,
	"./shadow.png": 2504,
	"./shap1.png": 5909,
	"./shape.png": 7127,
	"./sitting.png": 1307,
	"./slack.png": 8666,
	"./slider1.png": 372,
	"./slider2.png": 596,
	"./strategy.png": 3263,
	"./table.png": 6622,
	"./testimonial.svg": 1560,
	"./torrent.png": 27,
	"./tr_three.png": 8426,
	"./tr_two.png": 1231,
	"./triangle.png": 9609,
	"./twitter.png": 1966,
	"./wave.png": 6467,
	"./web-design.png": 2348
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4339;